import type {
  GetterClass,
  InstanceManagementState,
  InstanceSearchServiceConfig,
} from '../../../models'

export class SearchServiceConfigGetter implements GetterClass {
  static execute(this: void, state: InstanceManagementState): InstanceSearchServiceConfig {
    return state.searchServiceConfig
  }
}
